import React from "react";

export default function Knapsack_Item(props) {

	const handleOnChange = () => {
		// console.log("HANDLE " + props.id + "__" + !props.chosen);
		props.checkhandle(props.id, !props.chosen);
	};

	function roundToTwo(num) {
		return +(Math.round(num + "e+2") + "e-2");
	}

	const vw = roundToTwo(props.value / props.weight);


	return (
		// <li className="todo stack-small">
			<div id={"div" + props.id} className="c-cb">
				<input
					id={props.id}
					type="checkbox"
					checked={props.chosen}
					onChange={handleOnChange}
				/>
				<label
					className="todo-label"
					htmlFor={props.id}
					style={{ fontSize: 20 }}
				>
					{props.name} (size: {props.weight} value:{props.value} ratio: {vw})
				</label>
			</div>
		// </li>
	);
}
